import { PageHeader } from '@/components/PageHeader';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { EnhancedMobileApp } from '@/components/EnhancedMobileApp';
import { PWAFeatures } from '@/components/PWAFeatures';
import { EnhancedMobileFeatures } from '@/components/EnhancedMobileFeatures';

export default function MobileFeatures() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Mobile & PWA Features"
        description="Native mobile capabilities and progressive web app features"
      />
      
      <Tabs defaultValue="mobile" className="space-y-6">
        <TabsList>
          <TabsTrigger value="mobile">Mobile Interface</TabsTrigger>
          <TabsTrigger value="pwa">PWA Features</TabsTrigger>
          <TabsTrigger value="native">Native Features</TabsTrigger>
        </TabsList>
        
        <TabsContent value="mobile">
          <EnhancedMobileApp />
        </TabsContent>
        
        <TabsContent value="pwa">
          <PWAFeatures />
        </TabsContent>
        
        <TabsContent value="native">
          <EnhancedMobileFeatures />
        </TabsContent>
      </Tabs>
    </div>
  );
}